import { LogInfo } from 'utils/logging';

let questionAnsweredPath = '';

export function queueQuestionAnsweredPath(questionName: string): void {
  if (!questionAnsweredPath.includes(questionName)) {
    questionAnsweredPath += `${questionName} -> `;
  }
}

export function flushQuestionAnsweredPath(): string {
  const path = questionAnsweredPath;
  questionAnsweredPath = '';
  LogInfo('Question Answered Path', {
    description: path,
  });
  return path;
}
